var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiModel } from './api-model';
var TranslationType = /** @class */ (function (_super) {
    __extends(TranslationType, _super);
    function TranslationType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TranslationType.prototype, "percentTranslated", {
        get: function () {
            // if this.total = 0, to avoid division by, return 0
            if (this.total === 0) {
                return 0;
            }
            return Number((this.translated / this.total * 100).toFixed(2));
        },
        enumerable: true,
        configurable: true
    });
    return TranslationType;
}(ApiModel));
export { TranslationType };



// WEBPACK FOOTER //
// ./src/app/models/translation-type.ts.pre-build-optimizer.js